import { Component, OnInit } from '@angular/core';
import { OrganizationService } from '../../../../core/services/organization.service';
import { GlobalSettingsService } from '../../../../core/services/global-settings.service';
import { Group } from '../../../../core/models/organization.interface';

import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MultipleMessageComponent } from '../multiple-message/multiple-message.component';
import { ResponseModalComponent } from '../../response-modal/response-modal.component';

@Component({
  selector: 'app-group-list',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './group-list.component.html',
  styleUrl: './group-list.component.css'
})
export class GroupListComponent implements OnInit {
  groups: Group[] = [];
  numberInSelectedGroup = 0;
  query: { name: string } = { name: '' };

  constructor(
    private organizationService: OrganizationService,
    private globalSettings: GlobalSettingsService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
  }

  getSelectedGroupName(): string {
    const selectedGroup = this.globalSettings.getSelectedGroup();
     this.updateNumberInSelectedGroup();
    return selectedGroup ? selectedGroup.name : '';
  }

  getGroupList(): any[] {
    const items: any[] = [];
    const selectedGroup = this.globalSettings.getSelectedGroup();
    if (selectedGroup) {
      const orgTreeItemList = this.globalSettings.getOrgTreeItemList() || [];
      orgTreeItemList.forEach((item: any) => {
        if (
          item.group &&
          item.type === 'org' &&
          parseInt(item.group.groupId) === parseInt(selectedGroup.id)
        ) {
          items.push(item);
        }
      });
    }
    return items;
  }
  updateNumberInSelectedGroup(): void {
    this.numberInSelectedGroup = this.getGroupList().length;
  }
  sendGroupMail(node: any): void {
    let users: any[] = [];
    let orgIds: number[] = [];
    if (node.type === 'org') {
      users = this.getUsersByOrganizationIds([node.organization.id]);
    } else if (node.type === 'group') {
      orgIds = node.group.orgList.map((org: any) => org.id);
      users = this.getUsersByOrganizationIds(orgIds);
    }

    const items = users.map(user => ({
      id: user.userId,
      name: user.name,
      companyName: user.companyName,
      orgId: user.orgId,
      organization: user.organization
    }));

    const data = {
      isNewFormat: true,
      items
    };
    const title= 'Send Message';
    const showCancel = false;
    const userIds = items.map(item => item.id);
    const profiles: any[] = [];
    let completed = 0;
    if (userIds.length === 0) {
      const modalRef = this.modalService.open(MultipleMessageComponent, {
        size: 'md',
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });
      modalRef.componentInstance.title = title;
      modalRef.componentInstance.showCancel = showCancel;
      modalRef.componentInstance.users = data;
      return;
    }
    userIds.forEach((userId, idx) => {
      this.organizationService.getProfilesFromOrganization(userId).subscribe({
        next: (userInfo: any) => {
          profiles[idx] = userInfo;
          completed++;
          if (completed === userIds.length) {
            const modalRef = this.modalService.open(MultipleMessageComponent, {
              size: 'md',
              centered: true,
              backdrop: 'static',
              keyboard: false,
            });
            modalRef.componentInstance.title = title;
            modalRef.componentInstance.showCancel = showCancel;
            modalRef.componentInstance.users = data;
            modalRef.componentInstance.userInfo = data.items;
          }
        },
        error: (err: any) => {
        }
      });
    });
  }

  getUsersByOrganizationIds(organizationIds: number[]): any[] {
    const users: any[] = [];
    const allUserInfo = this.organizationService.data?.allUserInfo || [];
    allUserInfo.forEach((user: any) => {
      if (user.orgIds && user.orgIds.some((orgId: number) => organizationIds.includes(orgId))) {
        users.push(user);
      }
    });
    return users;
  }

  orgAlert(item?: any) {
    const modalRef = this.modalService.open(ResponseModalComponent, {
          centered: true,
          windowClass: 'response-modal-top zindex',
          backdropClass: 'response-modal-backdrop-top',
        });
        modalRef.componentInstance.message = 'No information to display.';
        modalRef.componentInstance.showCancel = false;
        return modalRef.result;
  }

  focusSearch(): void {
    const input = document.getElementById('searchinput') as HTMLInputElement;
    if (input) {
      input.focus();
    }
  }
}
